import { useMemo } from 'react'
import { Button } from '@overdose/components'

import classNames from 'classnames'
import { Icon } from '../Icon'
import Typography, { TypographyTag, TypographyVariant } from '../Typography'
import styles from './ProductListFilters.module.css'
import { FilterToggleButtonProps } from './ProductListFilters.types'

export const FilterToggleButton = ({
  label,
  filterId,
  selectedFilters,
  expectedFilterValue,
  onClick,
  buttonClassName = '',
}: FilterToggleButtonProps) => {
  const isChecked = useMemo(() => {
    const selectedFilterValues = selectedFilters[filterId] || []

    if (!selectedFilterValues.length) {
      return false
    }

    if (!expectedFilterValue?.length) {
      return true
    }

    if (Array.isArray(expectedFilterValue)) {
      return expectedFilterValue.some((filterValue) => {
        return selectedFilterValues.includes(filterValue)
      })
    }

    return selectedFilterValues.includes(expectedFilterValue)
  }, [filterId, expectedFilterValue, selectedFilters])

  return (
    <Button
      status='secondary'
      shape='rounded'
      theme={{
        root: classNames(styles.filterBtn, buttonClassName),
      }}
      iconAlignment='left'
      onClick={() => {
        onClick?.(filterId)
      }}>
      <div className='flex gap-2 items-center'>
        <Typography
          tag={TypographyTag.span}
          variant={TypographyVariant.BodySmallBold}
          className='text-primary-heading !normal-case'>
          {label}
        </Typography>
        <div
          className={classNames('relative rounded h-5 w-5 min-h-5 min-w-5', {
            'border-2 border-gray-200 bg-white': !isChecked,
            'bg-lime': isChecked,
          })}>
          <div
            className={classNames(
              'absolute inset-0 flex items-center justify-center',
              {
                hidden: !isChecked,
              }
            )}>
            <Icon iconName='check' color='#ffffff' />
          </div>
        </div>
      </div>
    </Button>
  )
}
